import { callAPI } from '../../network/networkConnection';

/**
 * Global Search Service
 * Handles API calls for global search functionality
 */
export const GlobalSearchService = {
  /**
   * Search across all collections
   * @param {string} query - Search term (min 2 chars)
   * @param {string} type - Search type: all, users, orders, products, subscriptions, inquiries
   * @param {number} page - Page number
   * @param {number} limit - Results per page
   */
  search: async (query, type = 'all', page = 1, limit = 10) => {
    const params = new URLSearchParams({
      query,
      type,
      page: page.toString(),
      limit: limit.toString(),
    });
    return callAPI(
      process.env.REACT_APP_APIUrl + `admin/global-search?${params.toString()}`,
      'GET',
      { 'Content-Type': 'application/json' },
      null
    );
  },
};

export default GlobalSearchService;
